import { useEffect } from 'react';
import { useOpenApp } from 'hooks';

const Index = () => {
  const { openApp } = useOpenApp()

  useEffect(() => {
    openApp();
  }, []);

  return null;
}

export default Index
